<template>
  <section class="mb-6 print:hidden">
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      <div>
        <label class="block text-sm text-gray-300 mb-2">Formulário</label>
        <select
          :value="filters.questionnaire_id || ''"
          class="w-full bg-zinc-800/80 border border-zinc-700 rounded-xl px-4 py-3 text-white outline-none"
          @change="onQuestionnaireChange"
        >
          <option value="">Selecione</option>
          <option
            v-for="item in questionnaireOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div>
        <label class="block text-sm text-gray-300 mb-2">Versão</label>
        <select
          :value="filters.questionnaire_version_id || ''"
          class="w-full bg-zinc-800/80 border border-zinc-700 rounded-xl px-4 py-3 text-white outline-none"
          @change="
            emitChange(
              'questionnaire_version_id',
              normalizeValue($event.target.value),
            )
          "
        >
          <option value="">Mais recente</option>
          <option
            v-for="item in versionOptions"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div>
        <label class="block text-sm text-gray-300 mb-2">Empresa</label>
        <select
          :value="filters.company_id || ''"
          class="w-full bg-zinc-800/80 border border-zinc-700 rounded-xl px-4 py-3 text-white outline-none"
          @change="
            emitChange('company_id', normalizeValue($event.target.value))
          "
        >
          <option value="">Todas</option>
          <option
            v-for="item in companies"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </option>
        </select>
      </div>

      <div>
        <label class="block text-sm text-gray-300 mb-2">Setor</label>
        <select
          :value="filters.role_id || ''"
          class="w-full bg-zinc-800/80 border border-zinc-700 rounded-xl px-4 py-3 text-white outline-none"
          @change="emitChange('role_id', normalizeValue($event.target.value))"
        >
          <option value="">Todos</option>
          <option v-for="item in roles" :key="item.value" :value="item.value">
            {{ item.label }}
          </option>
        </select>
      </div>
    </div>

    <div class="mt-4 flex flex-wrap gap-3">
      <button
        class="px-4 py-2 rounded-xl border border-zinc-700 text-white bg-zinc-800/80 hover:bg-zinc-700 transition"
        @click="$emit('apply')"
      >
        Aplicar filtros
      </button>

      <button
        class="px-4 py-2 rounded-xl border border-zinc-700 text-gray-300 hover:bg-zinc-800 transition"
        @click="$emit('reset')"
      >
        Limpar
      </button>

      <button
        class="px-4 py-2 rounded-xl border border-zinc-700 text-gray-300 hover:bg-zinc-800 transition"
        @click="printDashboard"
      >
        Resumo
      </button>
    </div>
  </section>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

defineProps({
  filters: {
    type: Object,
    required: true,
  },
  questionnaireOptions: {
    type: Array,
    default: () => [],
  },
  versionOptions: {
    type: Array,
    default: () => [],
  },
  companies: {
    type: Array,
    default: () => [],
  },
  roles: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(["change", "apply", "reset"]);

function normalizeValue(value) {
  return value === "" ? null : value;
}

function emitChange(key, value) {
  emit("change", { key, value });
}

function onQuestionnaireChange(event) {
  emit("change", {
    key: "questionnaire_id",
    value: normalizeValue(event.target.value),
  });
}

function printDashboard() {
  window.print();
}
</script>
